'use client'

import { curriculumTypeSchema } from '@server/schemas'
import { BottomNavigation } from '@shared/ui'
import { usePathname } from 'next/navigation'
import { use, useMemo } from 'react'

import { useBottomNavigationVisibility } from './bottom-navigation-visibility.context'

interface Props {
  hasOnlyCharacterChatSubscriptionTicketPromise: Promise<boolean>
  countryCodePromise: Promise<string | null | undefined>
}

export const isBottomNavigationVisiblePathname = (pathname: string | null) => {
  return (
    pathname === '/home' ||
    pathname === '/home/ai' ||
    pathname === '/subscribes' ||
    pathname === '/tutors' ||
    pathname === '/my-podo' ||
    pathname === '/reservation' ||
    pathname === '/ai-learning'
  )
}

export const BottomNavigationWithCondition = ({
  hasOnlyCharacterChatSubscriptionTicketPromise,
  countryCodePromise,
}: Props) => {
  const hasOnlyCharacterChatSubscriptionTicket = use(hasOnlyCharacterChatSubscriptionTicketPromise)
  const countryCode = use(countryCodePromise)
  const pathname = usePathname()
  const { isVisible } = useBottomNavigationVisibility()

  const isVisibleByPathname = useMemo(() => {
    return isBottomNavigationVisiblePathname(pathname)
  }, [pathname])

  if (!isVisibleByPathname || !isVisible) {
    return null
  }

  return (
    <BottomNavigation
      type={
        hasOnlyCharacterChatSubscriptionTicket ? curriculumTypeSchema.enum.SMART_TALK : curriculumTypeSchema.enum.BASIC
      }
      countryCode={countryCode}
    />
  )
}
